import script from "./HistoricoFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoricoFilter.vue?vue&type=script&setup=true&lang=js"

import "./HistoricoFilter.vue?vue&type=style&index=0&id=adbd21e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adbd21e2"]])

export default __exports__